// 地址配置：环境变量（REACT_APP_*，构建期注入）优先，未配置时回退到代码默认值，
// 不再把生产地址硬编码在源码中（05-5.8 配置漂移）。
// 注意 8654/8655 是 BFF 网关端口，与服务端直连端口不同。
export const BFF_SERVER_ADDRESS = process.env.REACT_APP_API_URL || 'https://api.ccdtn.com';
export const BFF_SERVER_PORT = Number(process.env.REACT_APP_BFF_PORT || 8654);
export const BFF_WS_PORT = Number(process.env.REACT_APP_BFF_WS_PORT || 8655);
export const bffServerAddress = `${BFF_SERVER_ADDRESS}:${BFF_SERVER_PORT}`;

const CLIENT_ID = 'memo-client-secret';
const BFF_PROXY_BASE = `${bffServerAddress}/api/bff/${CLIENT_ID}`;
const BFF_WS_HOST = BFF_SERVER_ADDRESS.replace('https://', '').replace('http://', '');
const BFF_WS_BASE = `wss://${BFF_WS_HOST}:${BFF_WS_PORT}/api/ws/${CLIENT_ID}`;
const BFF_WS_USER_BASE = `wss://${BFF_WS_HOST}:${BFF_WS_PORT}/api/ws/${CLIENT_ID}/user`;

export const userServerAddress = `${BFF_PROXY_BASE}/user`;
export const wmServerAddress = `${BFF_PROXY_BASE}/wm`;
export const messageServerAddress = `${BFF_PROXY_BASE}/message`;

export const WS_URL = BFF_WS_BASE;
export const USER_WS_URL = BFF_WS_USER_BASE;

export const hostServerAddress = 'https://web.wisememo.com';
// export const hostServerAddress = 'http://localhost:5555';

export const DEFAULT_SECTION_GUID = '_';
export const DEFAULT_GROUP_GUID = '_';

export const SOURCE_ID = 'CCDTN';

export const DEFAULT_LANGUAGE = 'zh';

export const MUI_LANGUAGE_MAP = {
  zh: 'zhCN',
  en: 'enUS'
} as const;

export type AppLanguage = 'zh' | 'en';
export type MuiLanguage = 'zhCN' | 'enUS';

// 280 与 memo-flutter 的 cc_design drawerWidth 令牌一致（cc_sizes.dart 默认 280）
export const drawerWidth = 280;
export const mainHeaderHeight = '40px';
export const appBarActualHeight = '48px';
export const mainFooterHeight = '30px';
export const mainContentMarginTop = '70px';
export const mainContentMarginTopSecondary = '50px';
export const mainContentMarginTopThird = '160px';
export const drawerHeaderMinHeight = '48px!important';
export const toolBarPaddingLeftRight = '1em!important';
export const leftListWidth = '300px';
export const editTopStatusHeight = '30px';

export const delayUpdate = 2000;
export const retryInterval = 30000;

export const maxLengthSectionName = 30;
export const maxLengthGroupName = 30;
export const maxLengthMemoTitle = 50;
export const maxLengthUserGroupName = 30;
export const maxWidthSectionBreadcrumb = '210px';
export const maxWidthGroupBreadcrumb = '280px';
